<template>
  <v-card class="rsl-fixed-height">

    <v-container class="width-override">
      <v-btn
        small
        class="mr-2 ma-3"
        color="secondary"
        @click="closeReport()"
      >{{ $t('REPORTS.BTNS.CLOSE') }}</v-btn>
      <v-stepper v-model="s1">
        <v-stepper-header>
          <v-stepper-step :complete="s1 > 1" step="1">{{ $t('REPORTS.BUILD_REPORT.TITLE_1') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="s1 > 2" step="2">{{ $t('REPORTS.BUILD_REPORT.TITLE_2') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="s1 > 3" step="3">{{ $t('REPORTS.BUILD_REPORT.TITLE_3') }}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form ref="nameReport" v-model="formValid" lazy-validation @submit.prevent>
              <v-row>
                <v-col cols="12">
                  <div class="pl-2 subtitle-1">{{ $t('REPORTS.BUILD_REPORT.DESC_1') }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_TITLE') }}</div>
                  <v-text-field
                    solo
                    v-model="reportTitle"
                    :label="$t('REPORTS.FIELDS.REPORT_TITLE_LABEL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_GROUPS') }}</div>
                  <v-autocomplete
                    solo
                    multiple
                    v-model="selectedGroups"
                    :items="allGroups"
                    item-text="name"
                    item-value="id"
                    :label="$t('REPORTS.FIELDS.REPORT_GROUPS_LABEL')"
                    :loading="fieldLoading"
                    :rules="[rules.select]"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_DESC') }}</div>
                  <v-textarea
                    solo
                    rows="3"
                    v-model="reportDesc"
                    :label="$t('REPORTS.FIELDS.REPORT_DESC_LABEL')"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>
              <v-row
                class="custom-margin"
              >
                <v-btn
                  absolute
                  right
                  depressed
                  color="secondary"
                  @click="continueForm('name')"
                  :disabled="!formValid"
                >
                  {{ $t('GENERAL.BTNS.CONTINUE') }}
                </v-btn>
              </v-row>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form ref="createReport" v-model="formValid" lazy-validation @submit.prevent>
              <v-row>
                <v-btn
                  absolute
                  right
                  depressed
                  color="error"
                  @click="resetQuery()"
                  class="resetQueryBtn"
                >
                  {{ $t('REPORTS.BTNS.RESET') }}
                </v-btn>
                <v-col cols="10">
                  <div class="pl-2 subtitle-1">{{ $t('REPORTS.BUILD_REPORT.DESC_2') }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable1"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                    :rules="[rules.select]"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields1"
                    :items="availableFields1"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(1)"
                    :loading="fieldLoading"
                    :rules="[rules.select]"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="1">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(2)"
                    :disabled="addBtn1"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Second Row -->
              <v-row v-if="activeRows.indexOf(2) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable2"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields2"
                    :items="availableFields2"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(2)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType2"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField2"
                    :items="availableJoins2"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(2)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(3)"
                    :disabled="addBtn2"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(2)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Third Row -->
              <v-row v-if="activeRows.indexOf(3) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable3"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields3"
                    :items="availableFields3"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(3)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType3"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField3"
                    :items="availableJoins3"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(3)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(4)"
                    :disabled="addBtn3"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(3)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fourth Row -->
              <v-row v-if="activeRows.indexOf(4) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable4"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields4"
                    :items="availableFields4"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(4)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType4"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField4"
                    :items="availableJoins4"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(4)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(5)"
                    :disabled="addBtn4"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(4)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fifth Row -->
              <v-row v-if="activeRows.indexOf(5) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable5"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields5"
                    :items="availableFields5"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(5)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType5"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField5"
                    :items="availableJoins5"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(5)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(6)"
                    :disabled="addBtn5"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(5)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Sixth Row -->
              <v-row v-if="activeRows.indexOf(6) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable6"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields6"
                    :items="availableFields6"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(6)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType6"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField6"
                    :items="availableJoins6"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(6)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(7)"
                    :disabled="addBtn6"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(6)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Seventh Row -->
              <v-row v-if="activeRows.indexOf(7) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable7"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields7"
                    :items="availableFields7"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(7)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType7"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField7"
                    :items="availableJoins7"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(7)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(8)"
                    :disabled="addBtn7"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(7)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Eighth Row -->
              <v-row v-if="activeRows.indexOf(8) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable8"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields8"
                    :items="availableFields8"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(8)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType8"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField8"
                    :items="availableJoins8"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(8)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(9)"
                    :disabled="addBtn8"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(8)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Ninth Row -->
              <v-row v-if="activeRows.indexOf(9) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable9"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields9"
                    :items="availableFields9"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(9)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType9"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField9"
                    :items="availableJoins9"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(9)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addRowBtn"
                    small
                    depressed
                    color="success"
                    @click="addRow(10)"
                    :disabled="addBtn9"
                  >
                    {{ $t('REPORTS.BTNS.ADD_ROW') }}
                  </v-btn>
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(9)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Tenth Row -->
              <v-row v-if="activeRows.indexOf(10) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.TABLE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="selectedTable10"
                    :items="availableTables"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.TABLE_LABEL')"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.FIELDS') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    multiple
                    v-model="selectedFields10"
                    :items="availableFields10"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.FIELDS_LABEL')"
                    @click="filterFields(10)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="joinType10"
                    :items="joinTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_TYPE_LABEL')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.JOIN_ON') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="joinField10"
                    :items="availableJoins10"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.JOIN_ON_LABEL')"
                    @click="filterJoins(10)"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="1">
                  <v-btn
                    class="removeRowBtn"
                    small
                    depressed
                    color="error"
                    @click="removeRow(10)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE_ROW') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="mb-5 report-divider"></v-divider>

              <!-- Where -->
              <v-row>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.WHERE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="where1"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.WHERE')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.OPERATOR') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="whereType1"
                    :items="whereTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.OPERATOR')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.VALUE') }}</div>
                  <v-text-field
                    solo
                    dense
                    v-model="whereValue1"
                    :label="$t('REPORTS.FIELDS.VALUE')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    class="addWhereBtn"
                    v-model="and1"
                    small
                    depressed
                    color="success"
                    @click="addWhere(2, 'and')"
                    :disabled="addWhereDisabled1"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.AND') }}
                  </v-btn>
                  <v-btn
                    class="addWhereBtn"
                    v-model="or1"
                    small
                    depressed
                    color="success"
                    @click="addWhere(2, 'or')"
                    :disabled="addWhereDisabled1"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.OR') }}
                  </v-btn>
                  <v-btn
                    class="clearWhereBtn"
                    small
                    depressed
                    color="error"
                    @click="clearWhere()"
                    :disabled="addWhereDisabled1"
                  >
                    {{ $t('REPORTS.BTNS.CLEAR') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Second Where -->
              <v-row v-if="activeWheres.indexOf(2) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.WHERE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="where2"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.WHERE')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.OPERATOR') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="whereType2"
                    :items="whereTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.OPERATOR')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.VALUE') }}</div>
                  <v-text-field
                    solo
                    dense
                    v-model="whereValue2"
                    :label="$t('REPORTS.FIELDS.VALUE')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    class="addWhereBtn"
                    v-model="and2"
                    small
                    depressed
                    color="success"
                    @click="addWhere(3, 'and')"
                    :disabled="addWhereDisabled2"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.AND') }}
                  </v-btn>
                  <v-btn
                    class="addWhereBtn"
                    v-model="or2"
                    small
                    depressed
                    color="success"
                    @click="addWhere(3, 'or')"
                    :disabled="addWhereDisabled2"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.OR') }}
                  </v-btn>
                  <v-btn
                    class="removeWhereBtn"
                    small
                    depressed
                    color="error"
                    @click="removeWhere(2)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Third Where -->
              <v-row v-if="activeWheres.indexOf(3) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.WHERE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="where3"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.WHERE')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.OPERATOR') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="whereType3"
                    :items="whereTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.OPERATOR')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.VALUE') }}</div>
                  <v-text-field
                    solo
                    dense
                    v-model="whereValue3"
                    :label="$t('REPORTS.FIELDS.VALUE')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    class="addWhereBtn"
                    v-model="and3"
                    small
                    depressed
                    color="success"
                    @click="addWhere(4, 'and')"
                    :disabled="addWhereDisabled3"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.AND') }}
                  </v-btn>
                  <v-btn
                    class="addWhereBtn"
                    v-model="or3"
                    small
                    depressed
                    color="success"
                    @click="addWhere(4, 'or')"
                    :disabled="addWhereDisabled3"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.OR') }}
                  </v-btn>
                  <v-btn
                    class="removeWhereBtn"
                    small
                    depressed
                    color="error"
                    @click="removeWhere(3)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fourth Where -->
              <v-row v-if="activeWheres.indexOf(4) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.WHERE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="where4"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.WHERE')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.OPERATOR') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="whereType4"
                    :items="whereTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.OPERATOR')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.VALUE') }}</div>
                  <v-text-field
                    solo
                    dense
                    v-model="whereValue4"
                    :label="$t('REPORTS.FIELDS.VALUE')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    class="addWhereBtn"
                    v-model="and4"
                    small
                    depressed
                    color="success"
                    @click="addWhere(5, 'and')"
                    :disabled="addWhereDisabled4"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.AND') }}
                  </v-btn>
                  <v-btn
                    class="addWhereBtn"
                    v-model="or4"
                    small
                    depressed
                    color="success"
                    @click="addWhere(5, 'or')"
                    :disabled="addWhereDisabled4"
                    active-class="btn-selected"
                  >
                    {{ $t('REPORTS.BTNS.OR') }}
                  </v-btn>
                  <v-btn
                    class="removeWhereBtn"
                    small
                    depressed
                    color="error"
                    @click="removeWhere(4)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fifth Where -->
              <v-row v-if="activeWheres.indexOf(5) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.WHERE') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="where5"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.WHERE')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.OPERATOR') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="whereType5"
                    :items="whereTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.OPERATOR')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.VALUE') }}</div>
                  <v-text-field
                    solo
                    dense
                    v-model="whereValue5"
                    :label="$t('REPORTS.FIELDS.VALUE')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="1">
                  <v-btn
                    class="removeWhereBtn"
                    small
                    depressed
                    color="error"
                    @click="removeWhere(5)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="mb-5 report-divider"></v-divider>

              <!-- Order -->
              <v-row>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_BY') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="orderBy1"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_BY')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="orderType1"
                    :items="orderTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_TYPE')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addOrderBtn"
                    v-model="order1"
                    small
                    depressed
                    color="success"
                    @click="addOrder(2)"
                    :disabled="addOrderDisabled1"
                  >
                    {{ $t('REPORTS.BTNS.ADD') }}
                  </v-btn>
                  <v-btn
                    class="clearOrderBtn"
                    small
                    depressed
                    color="error"
                    @click="clearOrder()"
                    :disabled="addOrderDisabled1"
                  >
                    {{ $t('REPORTS.BTNS.CLEAR') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Second Order -->
              <v-row v-if="activeOrders.indexOf(2) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_BY') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="orderBy2"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_BY')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="orderType2"
                    :items="orderTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_TYPE')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addOrderBtn"
                    v-model="order2"
                    small
                    depressed
                    color="success"
                    @click="addOrder(3)"
                    :disabled="addOrderDisabled2"
                  >
                    {{ $t('REPORTS.BTNS.ADD') }}
                  </v-btn>
                  <v-btn
                    class="removeOrderBtn"
                    small
                    depressed
                    color="error"
                    @click="removeOrder(2)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Third Order -->
              <v-row v-if="activeOrders.indexOf(3) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_BY') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="orderBy3"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_BY')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="orderType3"
                    :items="orderTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_TYPE')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addOrderBtn"
                    v-model="order3"
                    small
                    depressed
                    color="success"
                    @click="addOrder(4)"
                    :disabled="addOrderDisabled3"
                  >
                    {{ $t('REPORTS.BTNS.ADD') }}
                  </v-btn>
                  <v-btn
                    class="removeOrderBtn"
                    small
                    depressed
                    color="error"
                    @click="removeOrder(3)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fourth Order -->
              <v-row v-if="activeOrders.indexOf(4) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_BY') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="orderBy4"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_BY')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="orderType4"
                    :items="orderTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_TYPE')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="addOrderBtn"
                    v-model="order4"
                    small
                    depressed
                    color="success"
                    @click="addOrder(5)"
                    :disabled="addOrderDisabled4"
                  >
                    {{ $t('REPORTS.BTNS.ADD') }}
                  </v-btn>
                  <v-btn
                    class="removeOrderBtn"
                    small
                    depressed
                    color="error"
                    @click="removeOrder(4)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Fifth Order -->
              <v-row v-if="activeOrders.indexOf(5) !== -1">
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_BY') }}</div>
                  <v-autocomplete
                    solo
                    dense
                    v-model="orderBy5"
                    :items="whereOptions"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_BY')"
                    @click="filterWhere()"
                    :loading="fieldLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" md="2">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.ORDER_TYPE') }}</div>
                  <v-select
                    solo
                    dense
                    v-model="orderType5"
                    :items="orderTypes"
                    item-text="name"
                    item-value="val"
                    :label="$t('REPORTS.FIELDS.ORDER_TYPE')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="1">
                  <v-btn
                    class="removeOrderBtn"
                    small
                    depressed
                    color="error"
                    @click="removeOrder(5)"
                  >
                    {{ $t('REPORTS.BTNS.REMOVE') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>
              <v-row
                class="custom-margin"
              >
                <v-btn
                  absolute
                  left
                  depressed
                  color="success"
                  @click="buildQuery()"
                  :disabled="!formValid"
                >
                  {{ $t('REPORTS.BTNS.BUILD') }}
                </v-btn>

              </v-row>
              <v-row v-if="showResult">
                <v-col cols="12">
                  <div class="mt-2 body-2">{{ $t('REPORTS.BUILD_REPORT.ADV_MODE_DESC') }}</div>
                  <v-switch
                    dense
                    v-model="isAdvanced"
                    :label="$t('REPORTS.BUILD_REPORT.ADV_MODE_TOGGLE')"
                    class="ml-2"
                  >
                  </v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    solo
                    v-if="showResult"
                    v-model="buildResult"
                    :disabled="!isAdvanced"
                  >
                  </v-textarea>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>
              <v-row
                class="custom-margin"
              >
                <v-btn
                  absolute
                  left
                  depressed
                  color="warning"
                  @click="backClick()"
                >
                  {{ $t('GENERAL.BTNS.BACK') }}
                </v-btn>

                <v-btn
                  absolute
                  right
                  depressed
                  color="secondary"
                  @click="continueForm('create')"
                  :disabled="!formValid || !allowContinue"
                >
                  {{ $t('GENERAL.BTNS.CONTINUE') }}
                </v-btn>
              </v-row>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form ref="previewReport" v-model="formValid" lazy-validation @submit.prevent>
              <v-row>
                <v-col cols="6">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_TITLE') }}</div>
                  <v-text-field
                    solo
                    v-model="reportTitle"
                    :label="$t('REPORTS.FIELDS.REPORT_TITLE_LABEL')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_GROUPS') }}</div>
                  <v-autocomplete
                    solo
                    multiple
                    v-model="selectedGroups"
                    :items="allGroups"
                    item-text="name"
                    item-value="id"
                    :label="$t('REPORTS.FIELDS.REPORT_GROUPS_LABEL')"
                    disabled
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="pl-2 subtitle-2">{{ $t('REPORTS.FIELDS.REPORT_DESC') }}</div>
                  <v-textarea
                    solo
                    rows="3"
                    v-model="reportDesc"
                    :label="$t('REPORTS.FIELDS.REPORT_DESC_LABEL')"
                    disabled
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card>
                    <v-card-title>
                      <v-text-field
                        solo
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="$t('REPORTS.BUILD_REPORT.PREVIEW_SEARCH_TEXT')"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-data-table
                      :headers="headers"
                      :items="reportSqlData"
                      :items-per-page="25"
                      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                      :search="search"
                      class="elevation-1 mx-3 mb-3"
                      item-key="ID"
                      :sort-by="sortBy"
                      :sort-desc="sortDesc"
                      loading-text="Loading... Please wait"
                      :loading="loading"
                      fixed-header
                    >
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-row
                class="custom-margin"
              >
                <v-btn
                  absolute
                  left
                  depressed
                  color="warning"
                  @click="backClick()"
                >
                  {{ $t('GENERAL.BTNS.BACK') }}
                </v-btn>

                <v-btn
                  absolute
                  right
                  depressed
                  color="secondary"
                  @click="submitForm()"
                  :loading="loading"
                  :disabled="!formValid"
                >
                  {{ $t('GENERAL.BTNS.SAVE') }}
                </v-btn>
              </v-row>
            </v-form>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>

    </v-container>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="resetQueryDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('REPORTS.RESET_QUERY.TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('REPORTS.RESET_QUERY.DESC') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="resetQueryDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmResetQuery()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="snackTimeout"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'buildreport',
    computed: {
      ...mapGetters(['allDbTables', 'allGroups', 'errorMessage', 'reportSqlData', 'reportAction', 'rTitle', 'rDesc', 'rSql', 'rGroups', 'rData', 'reportId']),
    },
    data: function() {
      return {
        loading: false,
        fieldLoading: false,
        formValid: false,
        s1: 1,
        allowContinue: false,
        reportTitle: '',
        reportDesc: '',
        selectedGroups: [],
        selectedTable1: '',
        selectedTable2: '',
        selectedTable3: '',
        selectedTable4: '',
        selectedTable5: '',
        selectedTable6: '',
        selectedTable7: '',
        selectedTable8: '',
        selectedTable9: '',
        selectedTable10: '',
        selectedFields1: [],
        selectedFields2: [],
        selectedFields3: [],
        selectedFields4: [],
        selectedFields5: [],
        selectedFields6: [],
        selectedFields7: [],
        selectedFields8: [],
        selectedFields9: [],
        selectedFields10: [],
        joinField2: '',
        joinField3: '',
        joinField4: '',
        joinField5: '',
        joinField6: '',
        joinField7: '',
        joinField8: '',
        joinField9: '',
        joinField10: '',
        joinType2: '',
        joinType3: '',
        joinType4: '',
        joinType5: '',
        joinType6: '',
        joinType7: '',
        joinType8: '',
        joinType9: '',
        joinType10: '',
        availableFields1: [],
        availableFields2: [],
        availableFields3: [],
        availableFields4: [],
        availableFields5: [],
        availableFields6: [],
        availableFields7: [],
        availableFields8: [],
        availableFields9: [],
        availableFields10: [],
        availableJoins2: [],
        availableJoins3: [],
        availableJoins4: [],
        availableJoins5: [],
        availableJoins6: [],
        availableJoins7: [],
        availableJoins8: [],
        availableJoins9: [],
        availableJoins10: [],
        availableTables: [],
        addBtn1: false,
        addBtn2: false,
        addBtn3: false,
        addBtn4: false,
        addBtn5: false,
        addBtn6: false,
        addBtn7: false,
        addBtn8: false,
        addBtn9: false,
        allFields: [],
        activeRows: [1],
        where1: '',
        where2: '',
        where3: '',
        where4: '',
        where5: '',
        whereOptions: [],
        whereType1: '',
        whereType2: '',
        whereType3: '',
        whereType4: '',
        whereType5: '',
        whereValue1: '',
        whereValue2: '',
        whereValue3: '',
        whereValue4: '',
        whereValue5: '',
        and1: false,
        and2: false,
        and3: false,
        and4: false,
        and5: false,
        or1: false,
        or2: false,
        or3: false,
        or4: false,
        or5: false,
        addWhereDisabled1: false,
        addWhereDisabled2: false,
        addWhereDisabled3: false,
        addWhereDisabled4: false,
        activeWheres: [],
        orderBy1: '',
        orderBy2: '',
        orderBy3: '',
        orderBy4: '',
        orderBy5: '',
        orderType1: '',
        orderType2: '',
        orderType3: '',
        orderType4: '',
        orderType5: '',
        order1: false,
        order2: false,
        order3: false,
        order4: false,
        order5: false,
        addOrderDisabled1: false,
        addOrderDisabled2: false,
        addOrderDisabled3: false,
        addOrderDisabled4: false,
        activeOrders: [],
        joinTypes: [
          { name: 'INNER', val: 'INNER JOIN' },
          { name: 'LEFT', val: 'LEFT JOIN' },
          { name: 'RIGHT', val: 'RIGHT JOIN' },
          { name: 'CROSS', val: 'CROSS JOIN' }
        ],
        whereTypes: [
          { name: 'Equal', val: '=' },
          { name: 'Greater Than', val: '>' },
          { name: 'Less Than', val: '<' },
          { name: 'Greater Than or Equal', val: '>=' },
          { name: 'Less Than or Equal', val: '<=' },
          { name: 'Not Equal', val: '<>' },
          { name: 'Like', val: 'LIKE' },
          { name: 'Not', val: 'NOT' }
        ],
        andOrTypes: [
          { name: 'AND', val: 'AND' },
          { name: 'OR', val: 'OR' }
        ],
        orderTypes: [
          { name: 'Ascending', val: 'ASC' },
          { name: 'Descending', val: 'DESC' }
        ],
        lockedBy: '',
        createdBy: '',
        createdOn: '',
        updatedBy: '',
        updatedOn: '',
        buildResult: '',
        showResult: false,
        resetQueryDialog: false,
        isAdvanced: false,
        reportJson: [],
        rules: {
          required: value => !!value || 'This field is required.',
          select: value => !!(value && value.length) || 'This field is required.',
        },
        headers: [],
        search: '',
        sortBy: '',
        sortDesc: false,
        snack: false,
        snackColor: '',
        snackText: '',
        snackTimeout: 3000
      }
    },
    async created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'ERROR_MESSAGE') {
          this.snackErrorMessage();
        }

        if(mutation.type === 'REPORT_SQL_DATA') {
          this.goToPreview();
        }

        if(mutation.type === 'REPORT_DATA') {
          this.reportTitle = this.rTitle;
          this.reportDesc = this.rDesc;
          this.selectedGroups = JSON.parse(this.rGroups);
          this.buildResult = this.rSql;
          this.showResult = true;
          
          let jCount = 2;
          let wCount = 1;
          let oCount = 1;
          let data = JSON.parse(this.rData);
          for(let i = 0; i < data.length; i++) {
            if(data[i].type == 'select') {
              this.selectedTable1 = data[i].table;
              this.filterFields(1);
              this.selectedFields1 = data[i].fields;
            }
            if(data[i].type == 'join') {
              let table = 'selectedTable' + jCount;
              let fields = 'selectedFields' + jCount;
              let joinType = 'joinType' + jCount;
              let joinField = 'joinField' + jCount;
              let addBtn = 'addBtn' + (jCount - 1);
              this[table] = data[i].table;
              this.filterFields(jCount);
              this[fields] = data[i].fields;
              this[joinType] = data[i].joinType;
              this.filterJoins(jCount);
              this[joinField] = data[i].joinField;
              this.activeRows.push(jCount);
              this[addBtn] = true;
              jCount++;
            }
            if(data[i].type == 'where') {
              this.filterWhere();
              let where = 'where' + wCount;
              let whereType = 'whereType' + wCount;
              let whereValue = 'whereValue' + wCount;
              let andVal = 'and' + wCount;
              let orVal = 'or' + wCount;
              let addBtn = 'addWhereDisabled' + (wCount - 1);
              this[where] = data[i].where;
              this[whereType] = data[i].whereType;
              this[whereValue] = data[i].whereValue;
              this[andVal] = data[i].andVal;
              this[orVal] = data[i].orVal;
              this.activeWheres.push(wCount);
              this[addBtn] = true;
              wCount++;
            }
            if(data[i].type == 'order') {
              this.filterWhere();
              let order = 'orderBy' + oCount;
              let orderType = 'orderType' + oCount;
              let addBtn = 'addOrderDisabled' + (oCount - 1);
              this[order] = data[i].order;
              this[orderType] = data[i].orderType;
              this.activeOrders.push(oCount);
              this[addBtn] = true;
              oCount++;
            }
          }
        }
      });

      this.loading = true;
      await this.$store.dispatch('getAllTables').then( () => {
        this.reportTitle = this.rTitle;
        this.loading = false;
        this.fieldLoading = true;
        for(let i = 0; i < this.allDbTables.length; i++) {
          this.availableTables.push({ name: this.allDbTables[i].TABLE_NAME, val: this.allDbTables[i].TABLE_NAME });
          let tableData = JSON.parse(this.allDbTables[i].TABLE_DATA);
          
          for(let j = 0; j < tableData.length; j++) {
            this.allFields.push({ table: this.allDbTables[i].TABLE_NAME, type: tableData[j].fieldType, name: tableData[j].fieldName, val: tableData[j].fieldName });
          }
        }
        this.fieldLoading = false;
      });

      this.$store.dispatch('getAllGroups');

      if(this.reportAction == 'new') {
        this.activeWheres.push(1);
        this.activeOrders.push(1);
        this.createdBy = this.$store.state.currentUser;

        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        this.createdOn = dateTime;
      }

      if(this.reportAction == 'edit') {
        this.lockedBy = this.$store.state.currentUser;
        let data = {
          'reportId': this.reportId,
          'reportAction': this.reportAction,
          'lockedBy': this.lockedBy
        }

        await this.$store.dispatch('getReport', data).then( () => {
          this.updatedBy = this.$store.state.currentUser;

          let dt = new Date();
          let dateTime = new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(dt);

          this.updatedOn = dateTime;
        });
      }
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      filterFields(row) {
        this.fieldLoading = true;
        let fields = 'availableFields' + row;
        let table = 'selectedTable' + row;
        this[fields] = [];
        this[fields].push({ name: 'All (*)', val: '*' });
        for(let i = 0; i < this.allFields.length; i++) {
          if(this.allFields[i].table == this[table]) {
            this[fields].push({ name: this.allFields[i].name, val: this.allFields[i].val, type: this.allFields[i].type });
          }
        }
        this.fieldLoading = false;
      },
      filterJoins(row) {
        this.fieldLoading = true;
        let joins = 'availableJoins' + row;
        let table = 'selectedTable' + row;
        let field = 'joinField' + row;
        this[joins] = [];
        this[field] = '';
        let tableFields = [];

        for(let i = 0; i < this.allFields.length; i++) {
          if(this.allFields[i].table == this[table]) {
            tableFields.push(this.allFields[i]);
          }
        }

        for(let j = 1; j < row; j++) {
          let targetTable = 'selectedTable' + j;
          if(this[targetTable] != '') {
            for(let k = 0; k < tableFields.length; k++) {
              for(let l = 0; l < this.allFields.length; l++) {
                if(this.allFields[l].table == this[targetTable]) {
                  if(tableFields[k].name == this.allFields[l].name) {
                    let jName = this[targetTable] + '.' + this.allFields[l].name + ' = ' + this[table] + '.' + tableFields[k].name;
                    let jVal = this[targetTable] + '.' + this.allFields[l].name + ' = ' + this[table] + '.' + tableFields[k].name;
                    this[joins].push({ name: jName, val: jVal });
                  }
                }
              }
            }
          }
        }
        this.fieldLoading = false;
      },
      filterWhere() {
        for(let i = 0; i < this.activeRows.length; i++) {
          let table = 'selectedTable' + this.activeRows[i];
          let fields = 'availableFields' + this.activeRows[i];

          for(let j = 0; j < this[fields].length; j++) {
            if(this[fields][j].val != '*') {
              let wName = this[table] + '.' + this[fields][j].name;
              let wVal = this[table] + '.' + this[fields][j].name;
              let wType = this[fields][j].type;
              this.whereOptions.push({ name: wName, val: wVal, type: wType });
            }
          }
        }
      },
      addRow(row) {
        let btn = 'addBtn' + (row - 1);
        this[btn] = true;
        this.activeRows.push(row);
      },
      removeRow(row) {
        let btn = 'addBtn' + (row - 1);
        this[btn] = false;

        let sTable = 'selectedTable' + row;
        let sFields = 'selectedFields' + row;
        let aFields = 'availableFields' + row;
        let jFields = 'joinField' + row;
        let jType = 'joinType' + row;
        let aJoins = 'availableJoins' + row;
        
        for(let i = 0; i < this.activeRows.length; i++) {
          if(row == this.activeRows[i]) {
            this.activeRows.splice(i, 1);
            this[sTable] = '';
            this[sFields] = [];
            this[aFields] = [];
            this[jFields] = '';
            this[jType] = '';
            this[aJoins] = [];
            break;
          }
        }
      },
      addWhere(row, type) {
        if(type == 'and') {
          let andVal = 'and' + (row - 1);
          this[andVal] = true;
        }
        if(type == 'or') {
          let orVal = 'or' + (row - 1);
          this[orVal] = true;
        }
        
        let btn = 'addWhereDisabled' + (row - 1);
        this[btn] = true;
        this.activeWheres.push(row);
      },
      removeWhere(row) {
        let btn = 'addWhereDisabled' + (row - 1);
        this[btn] = false;
        let andVal = 'and' + (row - 1);
        this[andVal] = false;
        let orVal = 'or' + (row - 1);
        this[orVal] = false;

        let w = 'where' + row;
        let wType = 'whereType' + row;
        let wValue = 'whereValue' + row;
        let andOr = 'andOr' + row;
        
        for(let i = 0; i < this.activeWheres.length; i++) {
          if(row == this.activeWheres[i]) {
            this.activeWheres.splice(i, 1);
            this[w] = '';
            this[wType] = '';
            this[wValue] = '';
            this[andOr] = '';
            break;
          }
        }
      },
      clearWhere() {
        this.where1 = '';
        this.whereType1 = '';
        this.whereValue1 = '';
      },
      addOrder(row) {        
        let btn = 'addOrderDisabled' + (row - 1);
        this[btn] = true;
        this.activeOrders.push(row);
      },
      removeOrder(row) {
        let btn = 'addOrderDisabled' + (row - 1);
        this[btn] = false;

        let o = 'order' + row;
        let oType = 'orderType' + row;
        
        for(let i = 0; i < this.activeOrders.length; i++) {
          if(row == this.activeOrders[i]) {
            this.activeOrders.splice(i, 1);
            this[o] = '';
            this[oType] = '';
            break;
          }
        }
      },
      clearOrder() {
        this.orderBy1 = '';
        this.orderType1 = '';
      },
      buildQuery() {
        let valid = this.$refs.createReport.validate();

        if(valid) {
          let sqlSelect = '';
          let sqlFrom = 'HAR_' + this.selectedTable1;
          let sqlJoin = '';
          let sqlWhere = '';
          let sqlOrder = '';

          for(let i = 0; i < this.activeRows.length; i++) {
            let table = 'selectedTable' + this.activeRows[i];
            let fields = 'selectedFields' + this.activeRows[i];
            let joinType = 'joinType' + this.activeRows[i];
            let joinField = 'joinField' + this.activeRows[i];
            
            for(let j = 0; j < this[fields].length; j++) {
              sqlSelect += 'HAR_' + this[table] + '.' + this[fields][j] + ', ';
            }

            if(typeof this[joinType] !== 'undefined') {
              let str = this[joinField].split(' = ');
              let theJoin = 'HAR_' + str[0] + ' = HAR_' + str[1];

              sqlJoin += this[joinType] + ' HAR_' + this[table] + ' ON ' + theJoin + ' ';
            }
          }

          sqlSelect = sqlSelect.replace(/,\s*$/, "");
          sqlJoin = sqlJoin.replace(/\s*$/, "");

          for(let k = 0; k < this.activeWheres.length; k++) {
            let where = 'where' + this.activeWheres[k];
            let whereType = 'whereType' + this.activeWheres[k];
            let whereValue = 'whereValue' + this.activeWheres[k];
            let andVal = 'and' + this.activeWheres[k];
            let orVal = 'or' + this.activeWheres[k];
            let varType = '';

            if(typeof this[where] !== 'undefined' && this[where] != '') {
              sqlWhere += 'HAR_' + this[where] + ' ' + this[whereType] + ' ';
              
              for(let l = 0; l < this.whereOptions.length; l++) {
                if(this[where] == this.whereOptions[l].name) {
                  varType = this.whereOptions[l].type;
                  break;
                }
              }

              if(varType == 'Integer' || varType == 'Boolean') {
                sqlWhere += this[whereValue] + ' ';
              }else {
                sqlWhere += "'" + this[whereValue] + "' ";
              }

              if(this[andVal] != '') {
                sqlWhere += 'AND ';
              }
              if(this[orVal] != '') {
                sqlWhere += 'OR ';
              }
            }
          }

          for(let m = 0; m < this.activeOrders.length; m++) {
            let order = 'orderBy' + this.activeOrders[m];
            let orderType = 'orderType' + this.activeOrders[m];

            if(typeof this[order] !== 'undefined' && this[order] != '') {
              sqlOrder += 'HAR_' + this[order] + ' ' + this[orderType] + ', ';
            }
          }

          sqlOrder = sqlOrder.replace(/,\s*$/, "");

          let finalQuery = 'SELECT ' + sqlSelect + ' FROM ' + sqlFrom;
          if(sqlJoin != '') {
            finalQuery += ' ' + sqlJoin;
          }
          if(sqlWhere != '') {
            finalQuery += ' WHERE ' + sqlWhere;
          }
          if(sqlOrder != '') {
            finalQuery += ' ORDER BY ' + sqlOrder;
          }

          this.buildResult = finalQuery;
          this.showResult = true;
          this.allowContinue = true;
          this.buildJson();
        }
      },
      buildJson() {
        let json = [];

        for(let i = 0; i < this.activeRows.length; i++) {
          if(this.activeRows[i] == 1) {
            json.push({ type: 'select', table: this.selectedTable1, fields: this.selectedFields1 });
          }else {
            let table = 'selectedTable' + this.activeRows[i];
            let fields = 'selectedFields' + this.activeRows[i];
            let joinType = 'joinType' + this.activeRows[i];
            let joinField = 'joinField' + this.activeRows[i];
            json.push({ type: 'join', table: this[table], fields: this[fields], joinType: this[joinType], joinField: this[joinField] });
          }
        }
        
        for(let j = 0; j < this.activeWheres.length; j++) {
          let where = 'where' + this.activeWheres[j];
          let whereType = 'whereType' + this.activeWheres[j];
          let whereValue = 'whereValue' + this.activeWheres[j];
          let andVal = 'and' + this.activeWheres[j];
          let orVal = 'or' + this.activeWheres[j];
          json.push({ type: 'where', where: this[where], whereType: this[whereType], whereValue: this[whereValue], andVal: this[andVal], orVal: this[orVal] });
        }

        for(let k = 0; k < this.activeOrders.length; k++) {
          let order = 'orderBy' + this.activeOrders[k];
          let orderType = 'orderType' + this.activeOrders[k];
          json.push({ type: 'order', order: this[order], orderType: this[orderType] });
        }

        this.reportJson = json;
      },
      resetQuery() {
        this.resetQueryDialog = true;
      },
      confirmResetQuery() {
        this.resetQueryDialog = false;
        this.$refs.createReport.resetValidation();
        this.allowContinue = false;
        this.selectedTable1 = '';
        this.selectedTable2 = '';
        this.selectedTable3 = '';
        this.selectedTable4 = '';
        this.selectedTable5 = '';
        this.selectedTable6 = '';
        this.selectedTable7 = '';
        this.selectedTable8 =  '';
        this.selectedTable9 = '';
        this.selectedTable10 = '';
        this.selectedFields1 = [];
        this.selectedFields2 = [];
        this.selectedFields3 = [];
        this.selectedFields4 = [];
        this.selectedFields5 = [];
        this.selectedFields6 = [];
        this.selectedFields7 = [];
        this.selectedFields8 = [];
        this.selectedFields9 = [];
        this.selectedFields10 = [];
        this.joinField2 = '';
        this.joinField3 = '';
        this.joinField4 = '';
        this.joinField5 = '';
        this.joinField6 = '';
        this.joinField7 = '';
        this.joinField8 = '';
        this.joinField9 = '';
        this.joinField10 = '';
        this.joinType2 = '';
        this.joinType3 = '';
        this.joinType4 = '';
        this.joinType5 = '';
        this.joinType6 = '';
        this.joinType7 = '';
        this.joinType8 = '';
        this.joinType9 = '';
        this.joinType10 = '';
        this.availableFields1 = [];
        this.availableFields2 = [];
        this.availableFields3 = [];
        this.availableFields4 = [];
        this.availableFields5 = [];
        this.availableFields6 = [];
        this.availableFields7 = [];
        this.availableFields8 = [];
        this.availableFields9 = [];
        this.availableFields10 = [];
        this.availableJoins2 = [];
        this.availableJoins3 = [];
        this.availableJoins4 = [];
        this.availableJoins5 = [];
        this.availableJoins6 = [];
        this.availableJoins7 = [];
        this.availableJoins8 = [];
        this.availableJoins9 = [];
        this.availableJoins10 = [];
        this.addBtn1 = false;
        this.addBtn2 = false;
        this.addBtn3 = false;
        this.addBtn4 = false;
        this.addBtn5 = false;
        this.addBtn6 = false;
        this.addBtn7 = false;
        this.addBtn8 = false;
        this.addBtn9 = false;
        this.activeRows = [1];
        this.where1 = '';
        this.where2 = '';
        this.where3 = '';
        this.where4 = '';
        this.where5 = '';
        this.whereOptions = [];
        this.whereType1 = '';
        this.whereType2 = '';
        this.whereType3 = '';
        this.whereType4 = '';
        this.whereType5 = '';
        this.whereValue1 = '';
        this.whereValue2 = '';
        this.whereValue3 = '';
        this.whereValue4 = '';
        this.whereValue5 = '';
        this.and1 = false;
        this.and2 = false;
        this.and3 = false;
        this.and4 = false;
        this.and5 = false;
        this.or1 = false;
        this.or2 = false;
        this.or3 = false;
        this.or4 = false;
        this.or5 = false;
        this.addWhereDisabled1 = false;
        this.addWhereDisabled2 = false;
        this.addWhereDisabled3 = false;
        this.addWhereDisabled4 = false;
        this.activeWheres = [1];
        this.orderBy1 = '';
        this.orderBy2 = '';
        this.orderBy3 = '';
        this.orderBy4 = '';
        this.orderBy5 = '';
        this.orderType1 = '';
        this.orderType2 = '';
        this.orderType3 = '';
        this.orderType4 = '';
        this.orderType5 = '';
        this.order1 = false;
        this.order2 = false;
        this.order3 = false;
        this.order4 = false;
        this.order5 = false;
        this.addOrderDisabled1 = false;
        this.addOrderDisabled2 = false;
        this.addOrderDisabled3 = false;
        this.addOrderDisabled4 = false;
        this.activeOrders = [1];
        this.buildResult = '';
        this.showResult = false;
        this.isAdvanced = false;
        this.reportJson = [];
      },
      continueForm(form) {
        let valid = false;
        if(form == 'name') {
          valid = this.$refs.nameReport.validate();
        }else {
          valid = this.$refs.createReport.validate();
        }
        
        if(valid && this.s1 == 1) {
          this.s1++;
          valid = false;
        }
        if(valid && this.s1 == 2) {
          
          let payload = {
            'reportSql': this.buildResult
          };

          this.$store.dispatch('runReport', payload);
          valid = false;
        }
      },
      goToPreview() {
        this.headers = [];
        if(this.reportSqlData.length > 0) {
          let headerKeys = Object.keys(this.reportSqlData[0]);

          headerKeys.forEach((key, index) => {
            if(index == 0) {
              this.headers.push({ text: key, value: key, align: 'start', sortable: true });
            }else {
              this.headers.push({ text: key, value: key, sortable: true });
            }
          });
        }
        
        this.s1++;
      },
      saveReport() {
        let payload = {
          'reportId': this.reportId,
          'reportAction': this.reportAction,
          'reportData': JSON.stringify(this.reportJson),
          'reportTitle': this.reportTitle,
          'reportDesc': this.reportDesc,
          'reportGroups': JSON.stringify(this.selectedGroups),
          'reportSql': this.buildResult,
          'createdBy': this.createdBy,
          'createdOn': this.createdOn,
          'updatedBy': this.updatedBy,
          'updatedOn': this.updatedOn
        };
        this.$store.dispatch('saveReport', payload).then( () => {
          this.$store.commit('EDITING_REPORT', false);
          this.lockedBy = '';
          if(this.reportAction == 'new') {
            this.$router.push({ name: 'Reports' });
          }else {
            let payload = {
              'reportId': this.reportId,
              'checkType': 'unlock'
            };
            this.$store.dispatch('reportLockCheck', payload).then(() => {
              this.$router.push({ name: 'Reports' });
            });
          }
        });
      },
      backClick() {
        this.s1--;
      },
      submitForm() {
        this.saveReport();
      },
      closeReport() {
        this.lockedBy = '';
        if(this.reportAction == 'new') {
          this.$router.push({ name: 'Reports' });
        }else {
          let payload = {
            'reportId': this.reportId,
            'checkType': 'unlock'
          };
          this.$store.dispatch('reportLockCheck', payload).then(() => {
            this.$store.commit('EDITING_REPORT', false);
            this.$router.push({ name: 'Reports' });
          });
        }
      },
      snackErrorMessage () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.errorMessage + '. Please contact your System Administrator.';
      }
    }
  }
</script>

<style>
  .custom-margin {
    margin-top: 10px;
    margin-bottom: 35px;
  }
  textarea {
    padding-left: 10px !important;
  }
  .btn-selected {
    border: 1px solid #fb8c00;
  }
  .addRowBtn,
  .removeRowBtn,
  .addWhereBtn,
  .removeWhereBtn,
  .addOrderBtn,
  .removeOrderBtn,
  .clearWhereBtn,
  .clearOrderBtn {
    margin-top: 28px;
    margin-left: 10px;
  }
  .resetQueryBtn {
    margin-top: 12px;
  }
  .report-divider {
    border-color: #fb8c00 !important;
  }
</style>